export const ADD_SUBACCOUNT = 'ADD_SUBACCOUNT'
export const CHOOSE_DATE = 'CHOOSE_DATE'
export const LOGOUT_DIALOG = 'LOGOUT_DIALOG'
export const DELETE_SUBACCOUNT = 'DELETE_SUBACCOUNT'
export const CREATE_SUBACCOUNT = 'CREATE_SUBACCOUNT'
export const ADD_FINANCIAL_KEY = 'ADD_FINANCIAL_KEY'
export const EDIT_WALLET = 'EDIT_WALLET'
export const EDIT_EMAIL = 'EDIT_EMAIL'
export const CONFIRM_EDIT_EMAIL = 'CONFIRM_EDIT_EMAIL'
export const VERIFICATION_PENDING_ALERT = 'VERIFICATION_PENDING_ALERT'
export const VERIFICATION_ERROR_ALERT = 'VERIFICATION_ERROR_ALERT'
